import React from 'react';

import {AggregatorHero, BreadCrumb} from '@udemy/browse-aggregator';
import {
    BrowseNavigationItemSelected,
    BrowseNavigationItemStyle,
    BrowseNavigationItemType,
} from '@udemy/browse-event-tracking';
import {Tracker} from '@udemy/event-tracking';
import {useMatchMedia} from '@udemy/hooks';
import {
    CertificationPreparationLearnMoreSelected,
    CertificationPrepLearnMoreModal,
} from '@udemy/react-certification-preparation';
import {Button} from '@udemy/react-core-components';
import {safelySetInnerHTML} from '@udemy/shared-utils';

import {useCertificationBrowseAggregatorContext} from 'src/contexts/certification-browse-page-content-context';

import styles from './aggregator-hero-wrapper.module.less';

const LearnMore = () => {
    const isMobileMax = useMatchMedia('mobile-max');

    const LearnMoreButton = (
        <Button
            componentClass="a"
            className="ud-text-sm"
            udStyle="link-underline"
            onClick={() =>
                Tracker.publishEvent(
                    new CertificationPreparationLearnMoreSelected({
                        uiRegion: 'certification_banner',
                    }),
                )
            }
        >
            {gettext('Learn more')}
        </Button>
    );

    /**
     * This text used to have the Issued by copy,
     * it was removed on Dec 2025, @see https://udemyjira.atlassian.net/browse/CVR-1975
     */
    const learnMoreText = gettext('Prepare for your certification with these courses.');

    return (
        <div>
            {learnMoreText}{' '}
            <CertificationPrepLearnMoreModal trigger={LearnMoreButton} isMobile={!!isMobileMax} />
        </div>
    );
};

export const AggregatorHeroWrapper = () => {
    const certificationBrowseAggregatorContext = useCertificationBrowseAggregatorContext();
    const aggregatorEnrollmentStat = certificationBrowseAggregatorContext?.aggregatorEnrollmentStat;
    const aggregatorContent = certificationBrowseAggregatorContext?.aggregatorContent;

    const title = interpolate(
        gettext('%(title)s Courses'),
        {
            title: aggregatorContent?.title ?? '',
        },
        true,
    );

    const description = (
        <span
            className={styles['aggregator-hero-wrapper__description']}
            {...safelySetInnerHTML({
                descriptionOfCaller: 'aggregator-hero:description',
                html: aggregatorContent?.description ?? '',
            })}
        />
    );

    const breadcrumbs: BreadCrumb[] = [
        {
            id: 1,
            title: gettext('Certification Preparation'),
            // TODO: Technically this should be a <Link/> component since we're actually routing inside the app
            url: '/browse/certification/',
            onClick: () => {
                Tracker.publishEvent(
                    new BrowseNavigationItemSelected({
                        id: '0',
                        type: BrowseNavigationItemType.CERTIFICATION_PREPARATION,
                        uiRegion: 'related_categories_unit',
                        style: BrowseNavigationItemStyle.LINK,
                    }),
                );
            },
        },
        {
            id: 2,
            title: aggregatorContent?.title ?? '',
        },
    ];
    /**
     * Show more can create hydration problems and since we don't have
     * dom on server side, it's rendering show more button no matter what because it doesn't know if it's overflow or not.
     *
     * Just hide the show more on server side.
     */
    return (
        <AggregatorHero
            title={title}
            description={description}
            learnMoreUrl={''}
            breadcrumbs={breadcrumbs}
            enrollmentCount={aggregatorEnrollmentStat}
            learnMoreComponent={<LearnMore />}
            useShowMore={false}
        />
    );
};
